

export function getRef(value) {

    try {
        if(value.id) {
            return { id: value.id }
        } else {
            return value;
        }
    } catch (err) {
        return value;
    }

}

export function getNested(value, data) {

    return value.split('.').reduce((a, v) => a[v], data)
}

export function parse(value) {

    if (typeof value === 'string' || value instanceof String) {
        return JSON.parse(value);
    } else {
        return value;
    }

    
}
